import { BettingOffer } from "../BettingOffer";
import { Key } from "../Key";

export class KeyOffer {
	bettingTypeId: string;
	key?: Key;
	keyId: string;
	offers?: BettingOffer[];
}